@if (textOnly()) {
    <pre #runModeOutput [class]="themeClass()"></pre>
} @else {
    <ngx-codemirror
        fdxTrackVisibility
        (visible)="visibilityChange($event)"
        (cursorActivity)="cursorActivity.emit($event)"
        (drop)="drop.emit($event)"
        (focusChange)="onFocusChange($event)"
        (scroll)="scroll.emit($event)"
        [(ngModel)]="value"
        [autoFocus]="autoFocus"
        [className]="className"
        [name]="name"
        [options]="config()"
        [preserveScrollPosition]="preserveScrollPosition">
    </ngx-codemirror>
}
